import { computed, type Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { fetchComplianceMappings } from './report.endpoints';
import type { TComplianceMappingsPayload } from '../models/types';

export function useFetchComplianceMappings(payloadRef: Ref<TComplianceMappingsPayload | null>) {
  return useQuery({
    queryKey: computed(() => [
      'complianceMappings',
      payloadRef.value?.vulnerabilityUid,
      payloadRef.value?.integrationId,
    ]),
    queryFn: () => {
      const payload = payloadRef.value;
      if (!payload) {
        return Promise.reject(new Error('Compliance mappings payload is required'));
      }

      return fetchComplianceMappings(payload);
    },
    enabled: computed(
      () => !!payloadRef.value?.vulnerabilityUid && !!payloadRef.value?.integrationId
    ),
  });
}
